import Svg, { Path } from 'react-native-svg';
import { withDefaultIconProps } from './index';

export const LogoOneLinePartake = withDefaultIconProps(
  {
    height: 48,
    width: (48 * 1584) / 576,
  },
  ({ color, ...rest }) => (
    <Svg {...rest} viewBox="0 0 400 145">
      <Path
        d="M49.16 34.59H25V113.78H41.91V84.48H49.16C66.29 84.48 78.37 75.14 78.37 59.59C78.37 44.05 66.29 34.6 49.16 34.6V34.59ZM48.84 70.62H41.91V48.45H48.84C56.3 48.45 61.66 52.23 61.66 59.59C61.66 66.94 56.3 70.62 48.84 70.62Z"
        fill={color}
      />
      <Path
        d="M117.55 67.36C114.4 63.27 108.41 59.8 101.17 59.8C86.78 59.8 75.11 71.67 75.11 87.43C75.11 103.18 86.78 115.05 101.17 115.05C108.42 115.05 114.41 111.58 117.55 107.48V113.78H133.52V61.06H117.55V67.36V67.36ZM104.52 101.29C96.75 101.29 90.97 95.3 90.97 87.43C90.97 79.55 96.75 73.56 104.52 73.56C112.3 73.56 117.97 79.55 117.97 87.43C117.97 95.3 112.19 101.29 104.52 101.29Z"
        fill={color}
      />
      <Path
        d="M154.6 68.63V61.07H138.63V113.79H154.6V88.48C154.6 80.6 159.85 76.19 167.31 76.19C169.31 76.19 170.99 76.4 172.88 77.03V60.75C171.72 60.43 170.57 60.12 168.99 60.12C162.48 60.12 157.23 64 154.6 68.62L154.6 68.63Z"
        fill={color}
      />
      <Path d="M193.6 43.94H177.64V113.78H193.6V77.45H206.84V61.06H193.6V43.94Z" fill={color} />
      <Path
        d="M251.91 67.36C248.76 63.27 242.77 59.8 235.53 59.8C221.14 59.8 209.47 71.67 209.47 87.43C209.47 103.18 221.14 115.05 235.53 115.05C242.77 115.05 248.77 111.58 251.91 107.48V113.78H267.88V61.06H251.91V67.36V67.36ZM238.89 101.29C231.11 101.29 225.34 95.3 225.34 87.43C225.34 79.55 231.11 73.56 238.89 73.56C246.66 73.56 252.33 79.55 252.33 87.43C252.33 95.3 246.55 101.29 238.89 101.29Z"
        fill={color}
      />
      <Path
        d="M348.56 59.8C334.06 59.8 321.35 71.46 321.35 87.43C321.35 103.39 334.06 115.05 348.98 115.05C359.17 115.05 367.89 110.43 372.93 102.13L361.69 94.36C358.64 99.08 355.18 102.02 348.98 102.02C342.78 102.02 337.73 98.25 336.16 91.73H374.93C375.98 73.46 365.79 59.8 348.56 59.8ZM336.69 81.75C338.58 76.08 343.31 72.72 348.66 72.72C355.49 72.72 359.06 77.24 359.8 81.75H336.69Z"
        fill={color}
      />
      <Path
        d="M327.18 60.98H308.35L288.98 83.28V29H272.99V113.78H288.98V88.54L309.08 113.78H327.7L305.19 85.38L327.18 60.98Z"
        fill={color}
      />
    </Svg>
  ),
);
